/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ChosenDescriptionWithOrigin } from './';
import {
    ChosenDescriptionWithOriginFromJSON,
    ChosenDescriptionWithOriginFromJSONTyped,
    ChosenDescriptionWithOriginToJSON,
} from './';
import type { DurationWithOrigin } from './';
import {
    DurationWithOriginFromJSON,
    DurationWithOriginFromJSONTyped,
    DurationWithOriginToJSON,
} from './';
import type { ExpectedSourcingProcess } from './';
import {
    ExpectedSourcingProcessFromJSON,
    ExpectedSourcingProcessFromJSONTyped,
    ExpectedSourcingProcessToJSON,
} from './';
import type { LanguageWithOrigin } from './';
import {
    LanguageWithOriginFromJSON,
    LanguageWithOriginFromJSONTyped,
    LanguageWithOriginToJSON,
} from './';
import type { ProjectDescriptionWithOrigin } from './';
import {
    ProjectDescriptionWithOriginFromJSON,
    ProjectDescriptionWithOriginFromJSONTyped,
    ProjectDescriptionWithOriginToJSON,
} from './';
import type { ProjectTitleWithOrigin } from './';
import {
    ProjectTitleWithOriginFromJSON,
    ProjectTitleWithOriginFromJSONTyped,
    ProjectTitleWithOriginToJSON,
} from './';
import type { SkillsWithOrigin } from './';
import {
    SkillsWithOriginFromJSON,
    SkillsWithOriginFromJSONTyped,
    SkillsWithOriginToJSON,
} from './';
import type { StartDateWithOrigin } from './';
import {
    StartDateWithOriginFromJSON,
    StartDateWithOriginFromJSONTyped,
    StartDateWithOriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectCriteriaResponse
 */
export interface ProjectCriteriaResponse {
    /**
     * 
     * @type {ProjectTitleWithOrigin}
     * @memberof ProjectCriteriaResponse
     */
    title?: ProjectTitleWithOrigin;
    /**
     * 
     * @type {ChosenDescriptionWithOrigin}
     * @memberof ProjectCriteriaResponse
     */
    chosenDescription: ChosenDescriptionWithOrigin;
    /**
     * 
     * @type {ProjectDescriptionWithOrigin}
     * @memberof ProjectCriteriaResponse
     */
    inferredDescription?: ProjectDescriptionWithOrigin;
    /**
     * 
     * @type {ProjectDescriptionWithOrigin}
     * @memberof ProjectCriteriaResponse
     */
    originalDescription?: ProjectDescriptionWithOrigin;
    /**
     * 
     * @type {Array<LanguageWithOrigin>}
     * @memberof ProjectCriteriaResponse
     */
    languages?: Array<LanguageWithOrigin>;
    /**
     * 
     * @type {Array<SkillsWithOrigin>}
     * @memberof ProjectCriteriaResponse
     */
    skills?: Array<SkillsWithOrigin>;
    /**
     * 
     * @type {StartDateWithOrigin}
     * @memberof ProjectCriteriaResponse
     */
    startDate?: StartDateWithOrigin;
    /**
     * 
     * @type {DurationWithOrigin}
     * @memberof ProjectCriteriaResponse
     */
    duration?: DurationWithOrigin;
    /**
     * 
     * @type {ExpectedSourcingProcess}
     * @memberof ProjectCriteriaResponse
     */
    expectedSourcingProcess: ExpectedSourcingProcess;
}

/**
 * Check if a given object implements the ProjectCriteriaResponse interface.
 */
export function instanceOfProjectCriteriaResponse(value: object): value is ProjectCriteriaResponse {
    if (!('chosenDescription' in value) || value['chosenDescription'] === undefined) return false;
    if (!('expectedSourcingProcess' in value) || value['expectedSourcingProcess'] === undefined) return false;
    return true;
}

export function ProjectCriteriaResponseFromJSON(json: any): ProjectCriteriaResponse {
    return ProjectCriteriaResponseFromJSONTyped(json, false);
}

export function ProjectCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCriteriaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : ProjectTitleWithOriginFromJSON(json['title']),
        'chosenDescription': ChosenDescriptionWithOriginFromJSON(json['chosenDescription']),
        'inferredDescription': json['inferredDescription'] == null ? undefined : ProjectDescriptionWithOriginFromJSON(json['inferredDescription']),
        'originalDescription': json['originalDescription'] == null ? undefined : ProjectDescriptionWithOriginFromJSON(json['originalDescription']),
        'languages': json['languages'] == null ? undefined : ((json['languages'] as Array<any>).map(LanguageWithOriginFromJSON)),
        'skills': json['skills'] == null ? undefined : ((json['skills'] as Array<any>).map(SkillsWithOriginFromJSON)),
        'startDate': json['startDate'] == null ? undefined : StartDateWithOriginFromJSON(json['startDate']),
        'duration': json['duration'] == null ? undefined : DurationWithOriginFromJSON(json['duration']),
        'expectedSourcingProcess': ExpectedSourcingProcessFromJSON(json['expectedSourcingProcess']),
    };
}

export function ProjectCriteriaResponseToJSON(value?: ProjectCriteriaResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': ProjectTitleWithOriginToJSON(value['title']),
        'chosenDescription': ChosenDescriptionWithOriginToJSON(value['chosenDescription']),
        'inferredDescription': ProjectDescriptionWithOriginToJSON(value['inferredDescription']),
        'originalDescription': ProjectDescriptionWithOriginToJSON(value['originalDescription']),
        'languages': value['languages'] == null ? undefined : ((value['languages'] as Array<any>).map((v) => LanguageWithOriginToJSON(v))),
        'skills': value['skills'] == null ? undefined : ((value['skills'] as Array<any>).map((v) => SkillsWithOriginToJSON(v))),
        'startDate': StartDateWithOriginToJSON(value['startDate']),
        'duration': DurationWithOriginToJSON(value['duration']),
        'expectedSourcingProcess': ExpectedSourcingProcessToJSON(value['expectedSourcingProcess']),
    };
}

